<template>
  <div class="bypass">
    <div
      class="icon-reorder position-absolute bottom-0 left-0 h-100 d-flex"
      :class="[
        { 'fake-hide bypass': isReorder == false },
        customReorderIconClass ? customReorderIconClass : 'align-items-center',
        { 'fake-hide bypass': isHideTool == false },
      ]"
    >
      <reorder-icon
        class="size7px editor-icon render"
      />
    </div>
    <div
      class="icon-remove position-absolute bottom-0 right-0 h-100 d-flex"
      :class="[
        { 'fake-hide bypass': isRemove == false },
        customRemoveIconClass ? customRemoveIconClass : 'align-items-center',
        { 'fake-hide bypass': isHideTool == false },
      ]"
    >
      <feather-icon
        icon="Trash2Icon"
        size="9"
        class="editor-icon render"
        @click.stop="$emit('onRemove')"
      />
    </div>
  </div>
</template>

<script>
// import reorderIcon from "@/assets/images/svg/reoder.svg";

import reorderIcon from "@/@core/components/svg/code-template/ReorderIcon.vue";
import { tr } from "date-fns/locale";

export default {
  components: { reorderIcon },
  props: {
    customRemoveIconClass: null,
    customReorderIconClass: null,
    isReorder: true,
    isRemove: true,
    isHideTool: true,
  },
  setup() {},
};
</script>

<style scoped>
.icon-reorder svg {
  cursor: grab;
}
.icon-remove svg {
  cursor: pointer;
}
.editor-icon {
  color: #0dc4d8;
}
.size7px {
  width: 7px;
  height: 7px;
}
.size9px {
  width: 9px;
  height: 9px;
}
</style>
